<footer class="border-t border-base-300 py-6">
  <div
    class="container mx-auto px-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 text-sm text-base-content/60"
  >
    <span>&copy; {{ ctx.charity?.name ?? 'Givebrite' }} {{ year }}</span>
    <nav class="flex gap-4">
      <a [routerLink]="NavLinks.terms.path" class="link link-hover">{{ NavLinks.terms.label }}</a>
      <a [routerLink]="NavLinks.privacy.path" class="link link-hover">{{ NavLinks.privacy.label }}</a>
    </nav>
  </div>
</footer>
